import * as React from "react";
import { Row, Col, Alert } from "reactstrap";
import BasicTable from "../../../common/datatable/BasicTable";
import ConfirmModal from "./ConfirmModal";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { withRouter } from "react-router-dom";
import { Button, ButtonGroup } from "reactstrap";
import axios from "axios";
import _ from "lodash";
import { Constants } from "../../constants";
import { UserContext } from './../common/UserContext';

interface DataTableState {
  loading: boolean;
  triggerRender: boolean;
  data: any;
  selectedBanks: any;
  message: any;
}

class DataTable extends React.Component<any, DataTableState> {
  // Contructor
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      triggerRender: true,
      data: [],
      selectedBanks: [],
      message: { type: "success", isOpen: false, text: "" }
    };

    // events
    this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
    this.onConfirmAction = this.onConfirmAction.bind(this);
    this.onCancelAction = this.onCancelAction.bind(this);
    this.onAlertCloseAction = this.onAlertCloseAction.bind(this);
  }

  /**
   * Force the loading of the bank data once the page is rendered
   */
  componentDidMount() {
    this.setState({ loading: true }, () => {
      this.getBanks();
    });

  }

  /**
   * Fetch Bank Data
   */
  getBanks = () => {
    // For tests
    const DURI = Constants.APP_API;
    let URI: string = DURI + Constants.BANKLIST_FETCH_PUB_URI;
    if (this.props.type === "unpublish")
      URI = DURI + Constants.BANKLIST_FETCH_UNPUB_URI;

    axios.get(Constants.BANKLIST_USER_TOKEN).then((response) =>
      {
        var headerData = { 'Accept': 'application/json',
        'Content-type': 'application/json',
        'Authorization': 'Bearer ' + response.data };

        axios
        .get(URI, {headers: headerData})
        .then(resp => {
          // eslint-disable-next-line
          resp.data.map((d: any) => {
            d.fiscal = d.fiscalYear + "(" + d.fiscalQuarter + ")";
          });
          this.setState({ data: resp.data, loading: false });
        })
        .catch(err => {
          console.log(err);
          this.dataLoadErrorAlert(err);
          return null;
        });
      }).catch(err => {
        console.log(err);
        this.dataLoadErrorAlert(err);
        return null;
      });
    
  };

  /**
   * Notify the user that the bank list data filed to load
   */
  dataLoadErrorAlert(err: any) {
    this.setState({
      message: {
        type: "danger",
        isOpen: true,
        text: Constants.BANKLIST_ERROR_LOAD
      },
      data: [],
      loading: false
    });
  }

  /**
   * Table Cell Formatters
   */

  // Accoutn Text Field
  dateFormater = (
    cellContent: any,
    row: any,
    rowIndex: number,
    formatExtraData: any
  ) => {
    return <span>{cellContent}</span>;
  };

  /**
   * Bank Record Selection
   */
  onRadioBtnClick(rSelected: number) {
    this.setState(
      { loading: true, selectedBanks: [] },
      () => {
        this.getBanks();
        this.props.history.push("/drripbal/fdic/" + ( rSelected === 1 ? "publish" : "unpublish" ) );
      }
    );
    
  }

  /**
   * Bank Publish/Unpublish confirmation action
   */
  onConfirmAction() {
    const DURI = Constants.APP_API
    const uri: string =
      this.props.type === "publish"
        ? DURI + Constants.BANKLIST_UNPUBLISH_URI
        : DURI + Constants.BANKLIST_PUBLISH_URI;
        axios.get(Constants.BANKLIST_USER_TOKEN).then((response) =>
        {
          const headerData = { 'Accept': 'application/json',
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + response.data };
  
        axios
          .post(uri, this.state.selectedBanks, {headers:headerData})
          .then(resp => this._saveBankSuccess(resp))
          .catch(error => this._saveBankFailed(error));
        }).catch(err => {
          console.log(err.message);
          this.dataLoadErrorAlert(err.message);
          return null;
        });
  }

  /**
   * Successfull Bank save functionlity
   */
  _saveBankSuccess(response: any) {
    const successMessage: string =
      this.props.type === "publish"
        ? Constants.BANKLIST_UNPUBLISH_SUCCESS
        : Constants.BANKLIST_PUBLISH_SUCCESS;
    this.setState(
      {
        selectedBanks: [],
        message: { type: "success", isOpen: true, text: successMessage }
      },
      () => {
        this.getBanks();
      }
    );
  }

  /**
   * Failed Bank save functionlity
   */
  _saveBankFailed(error: any) {
    const faileMessage: string =
      this.props.type === "publish"
        ? Constants.BANKLIST_UNPUBLISH_FAILED
        : Constants.BANKLIST_PUBLISH_FAILED;
    this.setState({
      message: { type: "danger", isOpen: true, text: faileMessage }
    });
  }

  /**
   * Confrimation Cancel
   */
  onCancelAction() {
   
  }

  /**
   * Close Alert message
   */
  onAlertCloseAction() {
    this.setState({
      message: { type: "success", isOpen: false, text: "" }
    });
  }

  /**
   * Add selected bank to the list of banks to process
   * @param id String:  Bank ID Number
   */
  _addSelectedBank(id: string) {
    this.setState({
      selectedBanks: [...this.state.selectedBanks, id]
    });
  }

  /**
   * Remove selected bank from the list of banks to process
   * @param id String:  Bank ID Number
   */
  _removeSelectedBank(id: string) {
    const isFound: boolean = _.indexOf(this.state.selectedBanks, id) > -1;
    if (isFound) {
      this.setState(() => ({
        selectedBanks: this.state.selectedBanks.filter((x: any) => x !== id)
      }));
    }
  }

  /**
   * Adds list of selected banks to the list of banks to process
   * @param aBanks Array : List of Bank objects
   */
  _addSelectedBanks(aBanks: any) {
    let newBanks: any = aBanks.map((r: any) => r.id);
    this.setState({
      selectedBanks: [...this.state.selectedBanks, ...newBanks]
    });
  }

  /**
   * Removes list of selected banks to the list of banks to process
   * @param aBanks Array : List of Bank objects
   */

  _removeSelectedBanks(aBanks: any) {
    let currentBanks: any = this.state.selectedBanks;
    let removeBanks: any = aBanks.map((r: any) => r.id);
    let remainingBanks: any = _.remove(currentBanks, removeBanks);
    this.setState(() => ({
      selectedBanks: remainingBanks
    }));
  }

    /**
   * Adds list of selected banks to the list of banks to process
   * @param aBanks Array : List of Bank objects
   */
  _addAllBanks() {
    let newBanks: any = this.state.data.map((r: any) => r.id);
    this.setState({
      selectedBanks: [...this.state.selectedBanks, ...newBanks]
    });
  }

  /**
   * Removes list of selected banks to the list of banks to process
   * @param aBanks Array : List of Bank objects
   */

  _removeAllBanks() {
    this.setState(() => ({
      selectedBanks: []
    }));
  }

  render() {
    /**
     * Search Bar
     */
    const { SearchBar }: any = Search;

    /**
     * Table Cell Values
     */
    const columns: any = [
      {
        dataField: "legalName",
        text: Constants.BANKLIST_HEADER_BANKNAME,
        sort: true,
        headerAttrs: { scope: 'col', id: "aBankName" },
        attrs: { tabIndex: '0' },
        classes: 'aria-focus'
      },
      {
        dataField: "fundCode",
        text: Constants.BANKLIST_HEADER_FUND,
        sort: true,
        headerAttrs: { scope: 'col', id: "aBankCode" },
        attrs: (cell:any, row:any, rowIndex:any, colIndex:any) => (
          { tabIndex: '0', 'id': `fund_${rowIndex}` }
        ),
        classes: 'aria-focus'
      },
      {
        dataField: "fiscal",
        text: Constants.BANKLIST_HEADER_FISCAL,
        sort: true,
        headerAttrs: { scope: 'col', id: "aBankFiscal" },
        attrs: { tabIndex: '0' },
        classes: 'aria-focus'
      },
      {
        dataField: "fiscalQuarter",
        text: Constants.BANKLIST_HEADER_QUARTER,
        sort: true,
        hidden: true
      },
      {
        dataField: "published",
        text: Constants.BANKLIST_HEADER_STATUS,
        sort: true,
        formatter: (cell: any, row: any) =>
          row.published
            ? Constants.BANKLIST_PUBLISH
            : Constants.BANKLIST_UNPUBLISH,
        hidden: true,
        headerAttrs: { scope: 'col', id: "aBankPublish" },
        attrs: { tabIndex: '0' },
        classes: 'aria-focus'
      },
      {
        dataField: "publishedDate",
        text: Constants.BANKLIST_HEADER_PUBDATE,
        sort: true,
        hidden: this.props.type === "publish" ? false : true,
        headerAttrs: { scope: 'col', id: "aBankDate" },
        attrs: { tabIndex: '0' },
        classes: 'aria-focus'
      },
      {
        dataField: "publishedBy",
        text: Constants.BANKLIST_HEADER_PUBUSER,
        sort: true,
        hidden: this.props.type === "publish" ? false : true,
        headerAttrs: { scope: 'col', id: "aBankBy" },
        attrs: { tabIndex: '0' },
        classes: 'aria-focus'
      },
      {
        dataField: "lastActionDate",
        text: Constants.BANKLIST_HEADER_UPDATE,
        sort: true,
        formatter: this.dateFormater,
        headerAttrs: { scope: 'col', id: "aBankActionDate" },
        attrs: { tabIndex: '0' },
        classes: 'aria-focus'
      },
      {
        dataField: "lastActionBy",
        text: Constants.BANKLIST_HEADER_UPUSER,
        sort: true,
        headerAttrs: { scope: 'col', id: "aBankActionBy" },
        attrs: { tabIndex: '0' },
        classes: 'aria-focus'
      }
    ];

    // Data Table Default Sort
    const defaultSorted: any = [
      {
        dataField: "fundCode",
        order: "asc"
      }
    ];

    const selectRow: any = {
      mode: "checkbox",
      onSelect: (row: any, isSelect: boolean, rowIndex: number, e: any) => {
        if (isSelect) {
          this._addSelectedBank(row.id);
        } else {
          this._removeSelectedBank(row.id);
        }
      },
      onSelectAll: (isSelect: boolean, rows: any, e: any) => {
        if (isSelect) {
          this._addAllBanks();
        } else {
          this._removeAllBanks();
        }
      },
      selected: this.state.selectedBanks,
      selectionHeaderRenderer: ({ mode, checked, indeterminate }: any ) => {
        return (
          <input type={mode} 
          checked={checked} 
          aria-label="Check to select all Institutions"/>
        );
      },
      selectionRenderer: ( { mode, checked, disabled, rowIndex}: any ) => {
        return (
         <input type={mode} 
          checked={checked} 
          disabled={disabled} 
          aria-labelledby={"aBankCode fund_" + rowIndex}
          aria-describedby="aSelectInstructions"/>
        )
      }
    };

    // Row Events
    const rowEvents = {
      onClick: (e: any, row: any, rowIndex: number) => {
        if (("" + e.target.tagName).toUpperCase() === "INPUT") return;
        // redirect user to the details page
        this.props.history.push("/drripbal/fdic/bank/" + row.id);
      }
    };

    // might not need in future.
    const isPublishState: boolean = this.props.type === "publish" ? true : false;
    let data: any = _.filter(this.state.data, function(d: any) {
      return isPublishState === d.published;
    });

    const actionType: string =
      this.props.type === "publish"
        ? Constants.BANKLIST_UNPUBLISH
        : Constants.BANKLIST_PUBLISH;

    let pageActionButtons : any;
    if( !this.context.isReadOnly ){
      pageActionButtons = <ConfirmModal
        buttonLabel={actionType}
        className={"mymodal"}
        onConfirm={this.onConfirmAction}
        onCancel={this.onCancelAction}
        type={actionType}
        groupClassName="dataTableActionGroup"
      />
    }

    return (
      <Row>
        <Col md="12" lg="12" sm="auto">
          <Alert
            color={this.state.message.type}
            isOpen={this.state.message.isOpen}
            toggle={this.onAlertCloseAction}
          >
            {this.state.message.text}
          </Alert>
          <h1>{Constants.BANKLIST_TITLE}</h1>

          <div className="acctionGroup">
            <label>View By Status:</label>
            <ButtonGroup className="typeSelect">
              <Button
                color="primary"
                onClick={() => this.onRadioBtnClick(1)}
                active={this.props.type === "publish"}
              >
                {Constants.BANKLIST_PUBLISH + "ed"}
              </Button>
              <Button
                color="primary"
                onClick={() => this.onRadioBtnClick(2)}
                active={this.props.type === "unpublish"}
              >
                {Constants.BANKLIST_UNPUBLISH + "ed"}
              </Button>
            </ButtonGroup>

            {pageActionButtons}
            
          </div>

          <ToolkitProvider
            bootstrap4
            keyField="id"
            data={data}
            columns={columns}
            defaultSorted={defaultSorted}
            search
          >
            {(toolkitprops: any) => (
              <div>
                <SearchBar
                  {...toolkitprops.searchProps}
                  className="searchBar"
                />
                <BasicTable
                  {...toolkitprops.baseProps}
                  rowEvents={rowEvents}
                  selectRow={selectRow}
                  loading={this.state.loading}
                  defaultSorted={defaultSorted}
                />
              </div>
            )}
          </ToolkitProvider>
          <div id="aSelectInstructions" className="hideVisually">Click to select Institution for actions</div>
        </Col>
      </Row>
    );
  }
}
DataTable.contextType = UserContext;
export default withRouter(DataTable);
